import {cs}          from "./chain-services";
import {fragments}   from "./fragments";
import {Invoke}      from "./invoke";
import {OnUnmounted} from "./on-unmounted";
import {Static}      from "./static";
import {UseState}    from "./use-state";

export const ActiveEvents = ({events, next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => fragments(
        next({
            ref: (dom) => dom && !state.value && state.onChange(dom),
            reset: () => state.value && state.onChange(null),
        }),

        state.value && cs(
            ["onRemoveds", (_, next) => Static({initValue: [], next})],
            ({onRemoveds}) => fragments(
                Invoke({
                    props: {events},
                    fn: ({getLatestProps}) => {
                        const dom = state.value;

                        const list = [
                            {
                                reactName: "onWheel",
                                domName: "wheel",
                            },
                            {
                                reactName: "onTouchStart",
                                domName: "touchstart",
                            },
                            {
                                reactName: "onTouchEnd",
                                domName: "touchend",
                            },
                            {
                                reactName: "onTouchMove",
                                domName: "touchmove",
                            },
                            {
                                reactName: "onPointerLockChange",
                                domName: "pointerlockchange",
                                mozDomName: "mozpointerlockchange",
                            },
                        ];

                        list.forEach(({reactName, domName}) => {
                            if (!events[reactName]) {
                                return;
                            }
                            const listener = (e) => {
                                const {events} = getLatestProps();
                                events[reactName]?.(e);
                            };
                            dom.addEventListener(domName, listener);
                            onRemoveds.push(() => {
                                dom.removeEventListener(domName, listener);
                            })
                        });

                    },
                }),
                OnUnmounted({
                    action: () => onRemoveds.forEach((or) => or()),
                })
            ),
        ),
    ),
);
